import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b98012d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Ajouter une collection", -1))
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "flex flex-row flex-nowrap card-header border-0 w-full" }
const _hoisted_4 = { class: "flex card-toolbar w-full" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "p-input-icon-left w-10/12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "card-toolbar w-full mb-5 mt-5" }
const _hoisted_9 = { class: "formkit-selection" }
const _hoisted_10 = { class: "formkit-option" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "text-right italic"
}
const _hoisted_16 = { class: "card-body pt-0" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "ml-96 mt-10" }

import {computed, onBeforeMount, onMounted, ref, watch} from "vue";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import {fetchProductsForGrant, formatCategoriesProduct} from "@/_services/product/variant/productVariant";
import {createVariantProductCollection} from "@/_services/grant/variantProductCollection";
import router from "@/router";
import {
    IAddProductVariantToCollectionPlayload,
    IProductVariantForGrant
} from "@/models/product/variant/ProductVariantForGrant";
import {fetchCategoriesForDropDown} from "@/_services/category/category";

const tableLocalStorageKey = "tableSelectedProductsToAddInCollection";
const selectedProductToAddStorageKey = "selectedVariantProductsToAddInCollection";
const selectAllBtnStatusStorageKey = "selectAllVariantProductsForCollectionBtnStatus";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'AddVariantProductCollection',
  setup(__props) {

const isSelectAllBtnChecked = ref<boolean>(false);
const refItemsPerPage = ref<number>(0);
const isLoading = ref<boolean>(true);
const products = Array<IProductVariantForGrant>();
const tableData = ref<Array<IProductVariantForGrant>>(products);
const totalSelectedProducts = ref<number>(0);
const selectedProducts = ref(Array<IProductVariantForGrant>());
const productsOfCurrentPage = ref(Array<IProductVariantForGrant>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100, 250];
const selectedOptionsCategory = ref([]);
const isFormSubmitted = ref(false);
const collectionName = ref("");

onBeforeMount(() => {
    initLocalStorageData();
});

onMounted(async () => {
    await populateDataTableWithLocalStorageFilters();
});

watch(isSelectAllBtnChecked, () => {
    setIsSelectedAllBtnStatusLocalStorage(isSelectAllBtnChecked.value);
});

watch(selectedOptionsCategory, () => {
    onChangeSelectedCategory();
});

const isInFilteredView = computed(() => {
    return selectedOptionsCategory.value.length > 0 || totalSelectedProducts.value > 0;
});

const initLocalStorageData = () => {
    // Delete
    if (localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.removeItem(selectAllBtnStatusStorageKey);
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.removeItem(selectedProductToAddStorageKey);
    }

    // Create
    if (!localStorage.getItem(selectAllBtnStatusStorageKey)) {
        localStorage.setItem(selectAllBtnStatusStorageKey, 'false');
    }
    if (localStorage.getItem(tableLocalStorageKey)) {
        localStorage.removeItem(tableLocalStorageKey);
    }
    if (!localStorage.getItem(selectedProductToAddStorageKey)) {
        localStorage.setItem(selectedProductToAddStorageKey, '[]');
    }
}

async function searchCategories({ search, page, hasNextPage }) {
    const [totalCategoriesRecordsForPickListApi, categoriesForPickListApi] = await fetchCategoriesForDropDown(5, page, search);
    const hasItems = categoriesForPickListApi.length > 0;
    if (hasItems && page !== totalCategoriesRecordsForPickListApi) {
        hasNextPage();
    }

    return categoriesForPickListApi;
}

const canSubmitForm = (): boolean => {
    return !(totalSelectedProducts.value === 0 && collectionName.value === '');
}

const submitHandler = async (data) => {
  if (!canSubmitForm()) {
    swal.warning("Vous devez selectionner au moins un produit.")
  } else {
    swal
      .confirm("Êtes-vous sur de vouloir créer cette collection ?")
      .then((result) => {
        if (result.isConfirmed) {
          showSpinner();
          const params: IAddProductVariantToCollectionPlayload = {
              name: data.name,
              variantProductsUuids: getSelectedProductsUuids()
          }
          createVariantProductCollection(params).then(() => {
            swal.success("Créé !", "Vous venez de créer une collection").then(() => {
              router.push({ name: 'listVariantProductCollection'});
            });
          });
        }
      });
  
    isFormSubmitted.value = true;
  }
}

const onChangeSelectedCategory = async (): Promise<void> => {
    showSpinner();
    const search = criteria.value.trim();
    await populateDatatable(rows.value, page.value, "" != search ? search : "", selectedOptionsCategory.value);
};

const setIsSelectedAllBtnStatusLocalStorage = (status: boolean) =>{
    isSelectAllBtnChecked.value = status;
    const isSelectedAllBtnInStorageData = localStorage.getItem(selectAllBtnStatusStorageKey);
    if (!isSelectedAllBtnInStorageData) {
        localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
    } else {
        const currentStatus = JSON.parse(isSelectedAllBtnInStorageData);
        if (currentStatus !== status) {
            localStorage.setItem(selectAllBtnStatusStorageKey, status.toString());
        }
    }
}

function onSearchInputDt() {
    let search = criteria.value.trim();
    if (0 === search.length || 3 <= search.length) {
        showSpinner();
        populateDatatable(rows.value, page.value, "" != search ? search : "", selectedOptionsCategory.value);
    }
}

const populateDatatable = async (itemsPerPage: number, page: number, criteria?: string | undefined, categoriesFilter?: string[] | undefined) => {
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchProductsForGrant(itemsPerPage, page, criteria, categoriesFilter);
  totalRecords.value = totalRecordsDt;
  isLoading.value = loadingDt;
  tableData.value = tableDataDt;
  refItemsPerPage.value = itemsPerPage;
  productsOfCurrentPage.value = tableData.value;
    let selectedProductsOnCurrentPage: IProductVariantForGrant[] = [];
    selectedProductsOnCurrentPage = productsOfCurrentPage.value.filter((item: IProductVariantForGrant) =>
        getSelectedProductsToAddFromStorage().includes(item.uuid)
    );

    const totalUnSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (itemsPerPage - totalUnSelectedProductsOnCurrentPage) === itemsPerPage;
    selectedProducts.value = selectedProductsOnCurrentPage;
}

async function populateDataTableWithLocalStorageFilters(itemsPerPage?: number, page?: number) {
  let localStorageRowPerPage = getLocalStorageRowsPerPage();
  let localStorageFisrtPageState = getLocalStorageFisrtPageState();
  let currentPage = page;
  if (!currentPage) {
    currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
  }
  let currentItemsPerPage = itemsPerPage;
  if (!currentItemsPerPage) {
    currentItemsPerPage = localStorageRowPerPage;
  }

  await populateDatatable(currentItemsPerPage as number, currentPage, criteria.value, selectedOptionsCategory.value);
}

const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    setLocalStorageRowsPerPage(rows.value);
    await populateDataTableWithLocalStorageFilters(rows.value, page.value);
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

const onRowSelectAll = async (event): Promise<void> => {
    if (true === event.checked) {
        isSelectAllBtnChecked.value = true;
        selectedProducts.value = productsOfCurrentPage.value;
        const productsUuidsOfCurrentPageToSelect = productsOfCurrentPage.value
            .filter((item: IProductVariantForGrant) => !getSelectedProductsToAddFromStorage().includes(item.uuid))
            .map(item => item.uuid);
        if (productsUuidsOfCurrentPageToSelect.length > 0) {
            addSelectedProductInProductsToAddInStorage(productsUuidsOfCurrentPageToSelect);
            const currentProductsToAddInStorage = getSelectedProductsToAddFromStorage();
            let newProductsToAddInStorage = currentProductsToAddInStorage;
            productsUuidsOfCurrentPageToSelect.forEach((uuid: string) => {
                if (!currentProductsToAddInStorage.includes(uuid)) {
                    newProductsToAddInStorage.push(uuid);
                }
            });
            totalSelectedProducts.value = newProductsToAddInStorage.length;
        }
    } else {
        isSelectAllBtnChecked.value = false;
        const unSelectedProductsUuidsOfCurrentPageToRemoveInStorage = productsOfCurrentPage.value.map(item => item.uuid);
        removeUnSelectedProductFromProductsToAddInStorage(unSelectedProductsUuidsOfCurrentPageToRemoveInStorage);

        const productsToAddInStorage = getSelectedProductsToAddFromStorage();
        let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !unSelectedProductsUuidsOfCurrentPageToRemoveInStorage.includes(uuid));
        totalSelectedProducts.value = newProductsToAddInStorage.length;
        selectedProducts.value = selectedProducts.value.filter((item: IProductVariantForGrant) =>
            !productsOfCurrentPage.value.map((product: IProductVariantForGrant) => product.uuid).includes(item.uuid)
        );

        hideSpinner();
    }
};

const onRowSelect = async (event: any): Promise<void> => {
    const selectedProductUuid = event.data.uuid;
    totalSelectedProducts.value++;
    addSelectedProductInProductsToAddInStorage([selectedProductUuid]);
    const totalSelectedProductsOnCurrentPage = getTotalUnSelectedProductsOnCurrentPage();
    isSelectAllBtnChecked.value = (refItemsPerPage.value - totalSelectedProductsOnCurrentPage) === refItemsPerPage.value;
}

const onRowUnselect = async (event: any): Promise<void> => {
    const unSelectedProductUuid = event.data.uuid;
    removeUnSelectedProductFromProductsToAddInStorage([unSelectedProductUuid]);
    const productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !unSelectedProductUuid.includes(uuid));
    totalSelectedProducts.value = newProductsToAddInStorage.length;
    isSelectAllBtnChecked.value = false;
}

const getCurrentPageSelectedProductsUuids = () => {
    let localStorageData = getLocalStorageData();
    return localStorageData.selection.map(({ uuid }) => uuid);
}

function getSelectedProductsUuids() {
    return getSelectedProductsToAddFromStorage();
}

const getSelectedProductsToAddFromStorage = (): string[] => {
    const selectedProductsToAdd = localStorage.getItem(selectedProductToAddStorageKey);
    return selectedProductsToAdd ? JSON.parse(selectedProductsToAdd) : [];
}

const addSelectedProductInProductsToAddInStorage = (uuids: string[]) => {
    if (uuids.length === 0) {
        totalSelectedProducts.value = 0;
        localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify([]));
        return;
    }

    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    uuids.forEach(uuid => {
        if (!productsToAddInStorage.includes(uuid)) {
            productsToAddInStorage.push(uuid);
        }
    });
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(productsToAddInStorage));
}

const removeUnSelectedProductFromProductsToAddInStorage = (uuids: string[]) => {
    let productsToAddInStorage = getSelectedProductsToAddFromStorage();
    let newProductsToAddInStorage = productsToAddInStorage.filter(uuid => !uuids.includes(uuid));
    localStorage.setItem(selectedProductToAddStorageKey, JSON.stringify(newProductsToAddInStorage));
}

const getTotalUnSelectedProductsOnCurrentPage = (): number => {
    return productsOfCurrentPage.value
        .filter((item: IProductVariantForGrant) => !getSelectedProductsToAddFromStorage().includes(item.uuid)).length;
};

function getLocalStorageData() {
  let storageData = localStorage.getItem(tableLocalStorageKey);
  if (null !== storageData && "undefined" !== storageData) {
    return JSON.parse(storageData);
  }

  return null;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
  let storageData = localStorage.getItem(tableLocalStorageKey);
  if (storageData) {
    let localStorageObject = JSON.parse(storageData);
    localStorageObject.rows = rowPerPage;
    localStorage.setItem(tableLocalStorageKey, JSON.stringify(localStorageObject));
  }
}

function getLocalStorageRowsPerPage() {
  let localStorageData = getLocalStorageData();
  if (null !== localStorageData && localStorageData.rows) {
    return localStorageData.rows;
  }

  return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
  let localStorageData = getLocalStorageData();
  if (null !== localStorageData && localStorageData.first) {
    return localStorageData.first;
  }

  return 0;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_FormKit, {
      type: "form",
      "form-class": isFormSubmitted.value ? 'hide' : 'show',
      onSubmit: submitHandler,
      actions: false
    }, {
      default: _withCtx(({ state: { valid } }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(DataTable), {
            lazy: "",
            dataKey: "uuid",
            stateStorage: "local",
            ref: "dt",
            "state-key": tableLocalStorageKey,
            value: tableData.value,
            paginator: true,
            rows: rows.value,
            rowHover: true,
            sortMode: "multiple",
            removableSort: "",
            selection: selectedProducts.value,
            "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((selectedProducts).value = $event)),
            metaKeySelection: false,
            loading: isLoading.value,
            totalRecords: totalRecords.value,
            currentPage: currentPage.value,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            rowsPerPageOptions: rowsPerPageOptions,
            currentPageReportTemplate: "Affichage de {first} à {last} sur {totalRecords} entrées",
            selectAll: isSelectAllBtnChecked.value,
            onSelectAllChange: _cache[4] || (_cache[4] = ($event: any) => (onRowSelectAll($event))),
            onRowSelect: _cache[5] || (_cache[5] = ($event: any) => (onRowSelect($event))),
            onRowUnselect: _cache[6] || (_cache[6] = ($event: any) => (onRowUnselect($event))),
            onPage: _cache[7] || (_cache[7] = ($event: any) => (onPaginate($event)))
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_unref(InputText), {
                        type: "text",
                        modelValue: criteria.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                        placeholder: "Recherche",
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onSearchInputDt()), ["enter"]))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_FormKit, {
                  type: "autocomplete",
                  name: "autocomplete",
                  label: "Rechercher une catégorie",
                  placeholder: "Example: E-billet",
                  modelValue: selectedOptionsCategory.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedOptionsCategory).value = $event)),
                  options: searchCategories,
                  "selection-appearance": "option",
                  multiple: ""
                }, {
                  selection: _withCtx(({ option }) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, _toDisplayString(option.label), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, [
                  _createTextVNode("Nombre total de produits : "),
                  _createElementVNode("b", null, _toDisplayString(totalRecords.value), 1)
                ]),
                _createElementVNode("p", _hoisted_13, [
                  _createTextVNode("Nombre de produit sélectionné(s) : "),
                  _createElementVNode("b", null, _toDisplayString(totalSelectedProducts.value), 1),
                  _createTextVNode(" produit(s)")
                ]),
                _createTextVNode(),
                _hoisted_14,
                (isInFilteredView.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Vous êtes en vue filtrée"))
                  : _createCommentVNode("", true)
              ])
            ]),
            empty: _withCtx(() => [
              _createTextVNode("Aucun résultat trouvé.")
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(Column), { selectionMode: "multiple" }),
                _createVNode(_unref(Column), {
                  field: "name",
                  header: "Produit"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.data.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "category",
                  header: "Catégorie"
                }, {
                  body: _withCtx((slotProps) => [
                    (slotProps.data.categories?.length > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          title: _unref(formatCategoriesProduct)(slotProps.data.categories)
                        }, _toDisplayString(slotProps.data.categories[0].value), 9, _hoisted_17))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "price",
                  header: "Prix"
                }, {
                  body: _withCtx((slotProps) => [
                    _createElementVNode("span", null, _toDisplayString(slotProps.data.priceFormatted), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["value", "rows", "selection", "loading", "totalRecords", "currentPage", "selectAll"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_FormKit, {
            type: "text",
            name: "name",
            modelValue: collectionName.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((collectionName).value = $event)),
            label: "Nom de la collection*",
            validation: "required",
            "validation-messages": { required: 'Ce champ est obligatoire.' }
          }, null, 8, ["modelValue", "validation-messages"]),
          _createVNode(_component_FormKit, {
            type: "submit",
            label: "Enregistrer",
            disabled: !valid || totalSelectedProducts.value <= 0
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["form-class"])
  ], 64))
}
}

})